import { render } from "./UiPagination.vue?vue&type=template&id=0e03d161&ts=true"
import script from "./UiPagination.vue?vue&type=script&lang=ts"
export * from "./UiPagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__